import { render, staticRenderFns } from "./ResolutionIndex.vue?vue&type=template&id=5bf952ae"
import script from "./ResolutionIndex.vue?vue&type=script&lang=js"
export * from "./ResolutionIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports